import { fmtDate } from "@/lib/api";

const ALERT = { sent: "Emailed", failed: "Failed", pending: "Sending", no_contact: "No contact" };

export const DataTable = ({ rows, cols, testid }) => {
  if (rows === null) return <p className="overline text-[#575757]">Loading…</p>;
  if (!rows.length) return <p className="text-sm text-[#575757]" data-testid={`${testid}-empty`}>Nothing here yet.</p>;
  return (
    <div className="overflow-x-auto border border-[#E7E7E7] bg-white" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="bg-[#F4F4F4]">
          <tr>{cols.map(([k, l]) => <th key={k} className="text-left px-4 py-3 overline !text-[9px] text-[#575757]">{l}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} className="border-t border-[#E7E7E7]">
              {cols.map(([k]) => <td key={k} className="px-4 py-3 align-top max-w-[280px] truncate">{k === "created_at" ? fmtDate(r[k]) : k === "alert_status" ? <span className={`text-[10px] font-mono-d uppercase px-2 py-1 whitespace-nowrap ${r[k] === "sent" ? "bg-[#0A0A0A] text-white" : r[k] === "failed" ? "bg-[#FFF1F0] text-[#E5332A]" : "bg-[#F4F4F4] text-[#575757]"}`}>{ALERT[r[k]] || "—"}</span> : String(r[k] ?? "—")}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
